import { ROLES, normalizePermissionRole } from "@/consts/permissions"
import { useAuthStore } from "@/stores/authStore"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/admin/station-types")({
  beforeLoad: () => {
    const role = normalizePermissionRole(useAuthStore.getState().role)

    if (role !== ROLES.DEVELOPER) {
      throw redirect({ to: "/admin" })
    }
  },
})
